import React from 'react';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import DashboardButton from './DashboardButton';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const barbers = [
  { name: 'Rico', icon: <AccountCircleIcon fontSize="large" /> },
  { name: 'Resan', icon: <AccountCircleIcon fontSize="large" /> },
];

const BarberSelection = ({ selectedBarber, setSelectedBarber }) => {
  return (
    <>
      <Typography component="h2" variant="h6" sx={{ mb: 3, fontWeight: 500 }}>
        Select a Barber
      </Typography>
      <Grid container spacing={3} sx={{ mb: 5 }}>
        {barbers.map((barber) => (
         <Grid
              size={{ xs: 6, sm: 12 }} // 2 per row on mobile, full width on sm+
              key={barber.name}
              sx={{ 
                display: { sm: 'inline-flex' }, // Remove Grid styling on larger screens
                maxWidth: { sm: '200px' } // Match DashboardButton's sm width
              }}
            >
            <DashboardButton
              text={barber.name}
              icon={barber.icon}
              selected={selectedBarber?.name === barber.name} // Check the name property
              onClick={() => setSelectedBarber({ name: barber.name })} // Set as object
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default BarberSelection;